import { enableProdMode, importProvidersFrom, isDevMode } from '@angular/core';
import { environment } from '@environments/environment';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { bootstrapApplication } from '@angular/platform-browser';
import { CustomPreloadingStrategy } from '@core/common/providers/custom-preloading-strategy';
import {
  provideRouter,
  withInMemoryScrolling,
  withPreloading,
  withRouterConfig,
} from '@angular/router';
import { AppComponent } from '@app/app.component';
import { CoreModule } from '@core/core.module';
import APP_ROUTES from '@app/app-routing.module';
import { Overlay } from '@angular/cdk/overlay';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthorizationInterceptor } from "@core/interceptors";
import { provideServiceWorker } from '@angular/service-worker';

if (environment.production) {
  enableProdMode();
}



bootstrapApplication(AppComponent, {
  providers: [
    Overlay,
    MatSnackBar,
    provideHttpClient(withInterceptors([AuthorizationInterceptor]), withInterceptorsFromDi()),
    provideRouter(APP_ROUTES, withPreloading(CustomPreloadingStrategy), withRouterConfig({
        paramsInheritanceStrategy: 'always',
    }), withInMemoryScrolling({ scrollPositionRestoration: 'top' })
    // withDebugTracing(),
    ),
    importProvidersFrom(CoreModule),
    provideServiceWorker('ngsw-worker.js', {
        enabled: !isDevMode(),
        registrationStrategy: 'registerWhenStable:30000'
    }),
    provideServiceWorker('ngsw-worker.js', {
        enabled: !isDevMode(),
        registrationStrategy: 'registerWhenStable:30000'
    }),
    provideServiceWorker('ngsw-worker.js', {
        enabled: !isDevMode(),
        registrationStrategy: 'registerWhenStable:30000'
    }),
    provideServiceWorker('ngsw-worker.js', {
        enabled: !isDevMode(),
        registrationStrategy: 'registerWhenStable:30000'
    })
],
}).then();
